<script>
import api from "@/services/api/api-courses"
import Svc from "@/app/admin/models/courseService"
import CachedSvc from "@/app/admin/models/courseServiceCached"
import CourseModel from '../../../../models/courseModel'

export default {
  name: 'CourseChoose',
  render() {
    return this.$scopedSlots.default({
      hasCourseLocation: this.hasCourseLocation,
      loadCoursesDatesByLocation: this.loadCoursesDatesByLocation,
      loading: this.loading,
      courses: this.courses
    })
  },

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    svc: new CachedSvc(
      new Svc(api),
    ),
    loading: false,
    localCourses: []
  }),

  computed: {
    hasCourseLocation() {
      if(this.item.course.location) return true
      return false
    },
    courses() {
      return this.item.course.ID ? [this.item.course, ...this.localCourses] : this.localCourses
    }
  },

  mounted() {
    if(this.item.course.city) this.loadData(this.item.course.city)
  },

  methods: {
    async loadCoursesDatesByLocation(newLocation) {
      let course = new CourseModel()
      course.city = newLocation
      this.$emit('input:course', course)
      this.loadData(newLocation)
    },

    async loadData(newLocation) {
      try {
        this.loading = true
        const cachedLocation = this.svc.getCachedLocation(newLocation)
        if( cachedLocation && cachedLocation.find( ( { ID } ) => ID === this.item.course.ID ) ) {
          this.localCourses = cachedLocation
        } else {
          this.localCourses = await this.svc.getCoursesBy(newLocation, true)
        }
      } catch (error) {
        console.log(error)
      }
      finally {
        this.loading = false
      }
    },
  }
}
</script>
